export default "__VITE_ASSET__D0j8SKx0__"